import React from 'react';
import { ReactModal } from 'components/modal/style';
import { color } from 'styles/settings';

function Modal({ style, ...props }) {
  const { overlay } = style || {};

  const reactModalProps = {
    style: {
      overlay: {
        backgroundColor: color.brand.greenDarkWithOpacity(0.3),
        zIndex: 1000,
        ...(overlay || {}),
      },
    },
    ...props,
    onRequestClose: () => {
      if (props.shouldCloseOnOverlayClick) {
        props.modal.hide();
      }
    },
    closeTimeoutMS: 250,

    //ariaHideApp: false
  };

  return <ReactModal {...reactModalProps}>{props.children}</ReactModal>;
}

export default Modal;
